import React from 'react';
import { ThemeProvider } from './ThemeProvider';
import { DynamicI18nProvider } from './DynamicI18nProvider';
import { I18nProvider } from '../../i18n/context/I18nProvider';
import { AdEngineProvider } from '../../modules/monetization/context/AdEngineProvider';
import { AuthProvider } from './AuthProvider';
import { ModuleProvider } from './ModuleProvider';
import { ModalStackProvider } from '../components/ModalStackProvider';
import { IdleLockScreen } from '../auth/components/IdleLockScreen';
import { IdleWarningToast } from '../auth/components/IdleWarningToast';
import { StepUpChallengeModal } from '../auth/components/StepUpChallengeModal';

export const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <ThemeProvider>
      <I18nProvider>
        <DynamicI18nProvider>
          <AuthProvider>
            <AdEngineProvider>
              <ModuleProvider>
                <ModalStackProvider>
                  {children}
                  <IdleLockScreen />
                  <IdleWarningToast />
                  <StepUpChallengeModal />
                </ModalStackProvider>
              </ModuleProvider>
            </AdEngineProvider>
          </AuthProvider>
        </DynamicI18nProvider>
      </I18nProvider>
    </ThemeProvider>
  );
};
